/* tslint:disable */
/* eslint-disable */
/**
 * chinaone-java
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { GetDeliverFeeInternationalListRespVo } from './GetDeliverFeeInternationalListRespVo';
import {
    GetDeliverFeeInternationalListRespVoFromJSON,
    GetDeliverFeeInternationalListRespVoFromJSONTyped,
    GetDeliverFeeInternationalListRespVoToJSON,
    GetDeliverFeeInternationalListRespVoToJSONTyped,
} from './GetDeliverFeeInternationalListRespVo';

/**
 * 
 * @export
 * @interface ResponseListGetDeliverFeeInternationalListRespVo
 */
export interface ResponseListGetDeliverFeeInternationalListRespVo {
    /**
     * 接口状态码
     * @type {number}
     * @memberof ResponseListGetDeliverFeeInternationalListRespVo
     */
    code?: number;
    /**
     * 接口返回消息
     * @type {string}
     * @memberof ResponseListGetDeliverFeeInternationalListRespVo
     */
    message?: string;
    /**
     * 
     * @type {Array<GetDeliverFeeInternationalListRespVo>}
     * @memberof ResponseListGetDeliverFeeInternationalListRespVo
     */
    data?: Array<GetDeliverFeeInternationalListRespVo>;
}

/**
 * Check if a given object implements the ResponseListGetDeliverFeeInternationalListRespVo interface.
 */
export function instanceOfResponseListGetDeliverFeeInternationalListRespVo(value: object): value is ResponseListGetDeliverFeeInternationalListRespVo {
    return true;
}

export function ResponseListGetDeliverFeeInternationalListRespVoFromJSON(json: any): ResponseListGetDeliverFeeInternationalListRespVo {
    return ResponseListGetDeliverFeeInternationalListRespVoFromJSONTyped(json, false);
}

export function ResponseListGetDeliverFeeInternationalListRespVoFromJSONTyped(json: any, ignoreDiscriminator: boolean): ResponseListGetDeliverFeeInternationalListRespVo {
    if (json == null) {
        return json;
    }
    return {
        
        'code': json['code'] == null ? undefined : json['code'],
        'message': json['message'] == null ? undefined : json['message'],
        'data': json['data'] == null ? undefined : ((json['data'] as Array<any>).map(GetDeliverFeeInternationalListRespVoFromJSON)),
    };
}

export function ResponseListGetDeliverFeeInternationalListRespVoToJSON(json: any): ResponseListGetDeliverFeeInternationalListRespVo {
    return ResponseListGetDeliverFeeInternationalListRespVoToJSONTyped(json, false);
}

export function ResponseListGetDeliverFeeInternationalListRespVoToJSONTyped(value?: ResponseListGetDeliverFeeInternationalListRespVo | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'code': value['code'],
        'message': value['message'],
        'data': value['data'] == null ? undefined : ((value['data'] as Array<any>).map(GetDeliverFeeInternationalListRespVoToJSON)),
    };
}

